<template>
  <div class="d-flex justify-content-center align-items-center content-toast">
    <b-toast :variant="variant" :message="message">
      <p v-for="text in message" :key="text">
        {{ text }}
      </p>
    </b-toast>
  </div>
</template>

<script>
export default {
  props: ['message', 'variant'],
  data() {
    return {
      showToast: false,
    }
  },
  watch: {
    message(newValue) {
      if (newValue) {
        this.showToast = true
      }
    },
  },
}
</script>
<style lang="scss">
.content-toast {
  position: absolute;
  bottom: 150px;
  right: auto;
  left: auto;
}
</style>
